export default __webpack_public_path__ + "static/media/chef-cook.05080b14.png";